import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsProductsSoftwareConfigRoute: InvariantJiraRoute = {
	name: 'global-settings-products-software-config',
	path: '/secure/SoftwareConfig.jspa',
	query: ['decorator=admin'],
};
